<template>
    <div class="tariff-card">
        <input
            :id="compId"
            type="radio"
            :checked="modelValue === value"
            :value="value"
            v-bind="$attrs"
            @change="$emit('update:modelValue', value)"
            class="tariff-card__input"
        />
        <label
            v-if="label"
            :for="compId"
            class="tariff-card__label"
        >
            <span
                v-if="type !== 'individual'"
                class="tariff-card__content-default"
            >
                <span class="tariff-card__title">{{ label }}</span>
                <span class="tariff-card__radio"></span>
                <span class="tariff-card__euro">{{ costs[0] + '.' }}</span>
                <span class="tariff-card__cent">{{ costs[1] }}</span>
                <span class="tariff-card__duration">{{ '/' + duration }}</span>
                <span v-if="durationDescription" class="tariff-card__description">{{ durationDescription }}</span>
            </span>
            <span
                v-else
                class="tariff-card__content-default"
            >
                <span class="tariff-card__title">{{ label }}</span>
                <span class="tariff-card__radio"></span>
                <span class="tariff-card__euro"></span>
                <span class="tariff-card__cent"></span>
                <span class="tariff-card__duration"></span>
                <span v-if="durationDescription" class="tariff-card__description">{{ durationDescription }}</span>
            </span>

        </label>
    </div>
</template>

<script setup>
import {useId} from 'vue'

const compId = 'field-' + useId()
const props = defineProps({
    label: {
        type: String,
        default: '',
    },
    modelValue: {
        type: [String, Number],
        default: '',
    },
    value: {
        type: [String, Number],
        required: true,
    },
    type: {
        type: String,
        default: '',
    },
    duration: {
        type: String,
        default: '',
    },
    durationDescription: {
        type: String,
        default: '',
    },
    costs: Array,
})
</script>

<style lang="scss" scoped>
@use "../../css/mixins/typography";

.tariff-card {
    $scope: &;

    display: grid;
    min-width: 210px;

    &__input {
        display: none;

        &:checked + #{$scope}__label {
            outline: 2px solid var(--color-brand-primary);
            background-color: #fff;

            #{$scope}__radio {
                border: 2px solid var(--color-brand-primary);

                &::after {
                    display: block;
                    width: 22px;
                    height: 22px;
                    border-radius: 50%;
                    content: "";
                    position: absolute;
                    top: 2px;
                    left: 2px;
                    background-color: var(--color-brand-primary);
                }
            }
        }
    }

    &__label {
        display: block;
        padding: 20px;
        border: 2px solid var(--color-brand-primary);
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s ease;
        background-color: #fff;

        @media (any-hover: hover) {
            &:hover {
                border-color: var(--color-brand-secondary);
            }
        }
    }

    &__title {
        font-size: 20px;
        grid-area: title;
        color: var(--color-brand-primary);
        text-shadow: 0 0 1px var(--color-brand-primary);
    }

    &__radio {
        display: block;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        border: 2px solid #e0e0e0;
        align-self: center;
        position: relative;
    }

    &__euro{
        font-size: 50px;
        grid-area: euro;
        line-height: 1;
    }

    &__cent {
        grid-area: cent;
        padding-top: 5px;
        font-size: 24px;
        line-height: 1;
    }

    &__duration {
        grid-area: duration;
        font-size: 13px;
        margin-top: 2px;
        line-height: 1;
    }

    &__description {
        @include typography.label-small-quiet;

        grid-area: description;
    }

    &__content-default {
        display: grid;
        grid-template-areas:
            "title title radio"
            "euro cent ."
            "euro duration ."
            "description description .";
        grid-template-columns: auto 1fr;
        grid-template-rows: auto auto 2rem;
    }
}
</style>
